import { LoadingButton } from '@mui/lab';
import { Box, Button, Dialog, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import { Provider } from 'apps/wrapper/src/services/insurance/types/provider';
import { FC, useEffect, useState } from 'react';
import { DialogContent, DialogSubTitle, DialogTitle, DialogToolbar } from '../../../../shared/dialog/dialog.styles';

export interface ProviderSelectionDialogProps {
  open: boolean;
  title?: string;
  providers: Provider[];
  onSubmit: (providerId: number) => Promise<void>;
  onClose: () => void;
}

export const ProviderSelectionDialog: FC<ProviderSelectionDialogProps> = (props) => {
  const { open, title, providers, onSubmit, onClose } = props;
  const [selectedProviderId, setSelectedProviderId] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) setSelectedProviderId('');
  }, [open]);

  const handleProviderSelect = (event: SelectChangeEvent) => {
    setSelectedProviderId(event.target.value as string);
  };

  const handleProviderSubmit = async () => {
    setLoading(true);
    await onSubmit(parseInt(selectedProviderId));
    setLoading(false);
  };

  return (
    <Dialog open={open} maxWidth={false}>
      <DialogContent sx={{ width: '500px' }}>
        <DialogTitle>{title ?? 'Choose Provider'}</DialogTitle>
        <DialogSubTitle>Please select the provider the patients intends to see.</DialogSubTitle>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '20px' }}>
          <Typography variant="body1" sx={{ marginRight: '10px' }}>
            Provider:{' '}
          </Typography>
          <Select value={selectedProviderId} onChange={handleProviderSelect} size="small" sx={{ width: '300px' }}>
            {providers
              .filter((prov) => prov?.npi?.trim().length == 10 && prov.isRequired)
              .map((provider) => (
                <MenuItem key={provider.id} value={provider.id}>
                  {provider.name}
                </MenuItem>
              ))}
          </Select>
        </Box>
        <DialogToolbar>
          <Button onClick={onClose} disabled={loading} variant="outlined" disableElevation>
            Cancel
          </Button>
          <LoadingButton loading={loading} variant="contained" onClick={handleProviderSubmit} disableElevation>
            Next
          </LoadingButton>
        </DialogToolbar>
      </DialogContent>
    </Dialog>
  );
};
